export default __webpack_public_path__ + "static/media/img--LUX-terrace-1.528f8368.jpg";